import type { TripSection } from "../lib/router.tsx";
import { editorOnly } from "../shell/Shell.tsx";

/**
 * Which of an editor's own surfaces a section is. The map is built — `EditorMapPage`, a desktop
 * review surface rather than the traveller's day dial — and so is
 * deliverables, `EditorBoard`. Anyone who is also an admin keeps the ordinary pages, so nothing is
 * taken away from the person running the trip.
 */
export function editorSurface(
  section: TripSection,
  roles: string[],
): "map" | "deliverables" | null {
  if (!editorOnly(roles)) return null;
  return section === "map" || section === "deliverables" ? section : null;
}
